export default {
  'common.more': '更多',
  'common.fold': '收起',
  'common.noData': '暂无数据',
  'common.success': '操作成功',
  'common.docTitle': '布瑞克帕特(河北)机械科技有限公司'
}
